import { PartState } from '../types';
import { curiousState } from './curious';

/**
 * Facing left state — Mirror of facing-right. Bizy rotated significantly
 * to the left. Only the left eye is visible; the right eye collapses
 * to the body edge. Badge IS visible (on the viewer-facing side).
 * Right arm wraps in front, left arm behind body.
 */
export const facingLeftState: PartState = {
	antenna1: {
		path: 'M167.286 36.02C170.046 36.02 172.286 38.26 172.286 41.02C172.286 43.78 170.046 46.02 167.286 46.02C165.656 46.02 164.206 45.24 163.296 44.03C157.146 45.30 152.236 48.79 148.236 53.03C143.516 58.30 140.646 64.60 139.486 68.71C139.106 70.04 137.726 70.81 136.396 70.43C135.066 70.05 134.296 68.67 134.676 67.34C136.016 62.61 139.206 55.60 144.516 49.67C148.916 44.75 154.876 40.48 162.496 39.02C163.266 37.24 165.036 36.02 167.286 36.02Z',
	},
	antenna2: {
		path: 'M181.306 36.02C184.076 36.02 186.316 38.26 186.316 41.02C186.316 43.78 184.076 46.02 181.306 46.02C179.566 46.02 178.036 45.15 177.136 43.81C170.366 44.83 165.016 48.50 160.946 53.03C156.216 58.30 153.346 64.60 152.186 68.71C151.806 70.04 150.426 70.81 149.096 70.43C147.766 70.05 146.996 68.67 147.376 67.34C148.716 62.61 151.906 55.60 157.216 49.67C161.936 44.27 168.436 39.47 177.836 38.34C178.656 36.70 180.356 36.02 181.306 36.02Z',
	},
	body: { x: 100, y: 62, width: 100, height: 162, rx: 32 },
	bodyHighlight: { x: 113, y: 62, width: 87, height: 162, rx: 32 },
	stripes: { y1: 140, y2: 169, y3: 198, height: 15 },
	eyes: {
		// Left eye visible within body bounds
		leftPath:
			'M113 100.5C113 97.462 115.462 95 118.5 95C121.538 95 124 97.462 124 100.5C124 100.5 124 107.5 124 107.5C124 110.538 121.538 113 118 113C117.5 113 117.5 113 117 113C115.462 113 113 110.538 113 107.5C113 107.5 113 100.5 113 100.5Z',
		// Right eye slides past body left edge (x=100) — clipped away by body clip path
		rightPath:
			'M80 100.5C80 97.462 82.462 95 85.5 95C88.538 95 91 97.462 91 100.5C91 100.5 91 107.5 91 107.5C91 110.538 88.538 113 85 113C84.5 113 84.5 113 84 113C82.462 113 80 110.538 80 107.5C80 107.5 80 100.5 80 100.5Z',
	},
	// Wings bunched on the right side (mirrored from facing-right)
	wing1Path:
		'M233.738 133.33C221.949 155.59 192.858 152.03 181.674 150.5C180.808 150.33 180.346 148.54 180.844 147.3C194.951 112.11 222.233 86.14 236.405 75.21C251.069 63.99 244.081 115.71 233.738 133.33Z',
	wing2Path:
		'M236.085 157.891C223.502 174.551 194.595 150.981 184.762 142.191C183.979 141.531 183.902 139.591 184.62 138.701C202.182 112.071 234.129 104.931 248.005 102.201C262.331 99.451 247.999 149.241 236.085 157.891Z',
	wing3Path:
		'M229.377 133.33C217.588 155.59 188.498 152.03 177.313 150.5C176.448 150.33 175.985 148.54 176.483 147.3C190.59 112.11 217.873 86.14 232.045 75.21C246.709 63.99 239.72 115.71 229.377 133.33Z',
	wing4Path:
		'M231.725 157.891C219.141 174.551 190.234 150.981 180.401 142.191C179.619 141.531 179.542 139.591 180.259 138.701C197.821 112.071 229.769 104.931 243.644 102.201C257.97 99.451 243.638 149.241 231.725 157.891Z',
	arms: [
		{ d: 'M149 139L145 166.7C144.6 168 144.6 168.5 144.2 169.12L131 183', side: 'left' },
		{ d: 'M131 140.17L125 167.8C124.83 168.68 124.43 169.5 123.86 170.2L115 180.87', side: 'right' },
	],
	armOrder: 'rightFront',
	antennaOrder: 'rightFront',
	stinger: curiousState.stinger,
	badge: {
		outerEllipse: { cx: 125, cy: 143.76, rx: 14.1, ry: 10.86 },
		innerEllipse: { cx: 125, cy: 143.76, rx: 12.19, ry: 9.34 },
		starPath:
			'M125 130.58C125.75 130.58 126.4 131.09 126.6 131.82L128.55 139.24L134.09 142.47C134.6 142.77 134.91 143.32 134.91 143.91C134.91 144.51 134.6 145.06 134.09 145.36L128.55 148.59L126.6 156.01C126.4 156.74 125.75 157.25 125 157.25C124.25 157.25 123.6 156.74 123.4 156.01L121.45 148.59L115.91 145.36C115.4 145.06 115.09 144.51 115.09 143.91C115.09 143.32 115.4 142.77 115.91 142.47L121.45 139.24L123.4 131.82C123.6 131.09 124.25 130.58 125 130.58Z',
		starHighlightPath:
			'M126.6 131.82C126.4 131.09 125.75 130.58 125 130.58C124.25 130.58 123.6 131.09 123.4 131.82L121.45 139.24L115.91 142.47L123.98 144.88C124.65 145.08 125.35 145.08 126.02 144.88L134.09 142.47L128.55 139.24L126.6 131.82Z',
	},
};
